import React from 'react';

const TitleTextPage = ({ title, text, onTitleChange, onTextChange }) => {
    return (
        <div>
            <input
                type="text"
                placeholder="Título"
                value={title}
                onChange={(e) => onTitleChange(e.target.value)}
            />
            <textarea
                placeholder="Texto"
                value={text}
                onChange={(e) => onTextChange(e.target.value)}
            />
        </div>
    );
};

export default TitleTextPage;
